/******/ (() => {
  // webpackBootstrap
  /******/ "use strict";
  /******/ var __webpack_modules__ = {
    /***/ "./node_modules/alpinejs/src/datas.js":
      /*!********************************************!*\
  !*** ./node_modules/alpinejs/src/datas.js ***!
  \********************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ data: () => /* binding */ data,
          /* harmony export */ injectDataProviders: () =>
            /* binding */ injectDataProviders,
          /* harmony export */
        });

        let datas = {};

        function data(name, callback) {
          datas[name] = callback;
        }

        function injectDataProviders(obj, context) {
          Object.entries(datas).forEach(([name, callback]) => {
            Object.defineProperty(obj, name, {
              get() {
                return (...args) => {
                  return callback.bind(context)(...args);
                };
              },

              enumerable: false,
            });
          });

          return obj;
        }

        /***/
      },

    /******/
  };
  /************************************************************************/
  /******/ // The module cache
  /******/ var __webpack_module_cache__ = {};
  /******/
  /******/ // The require function
  /******/ function __webpack_require__(moduleId) {
    /******/ // Check if module is in cache
    /******/ var cachedModule = __webpack_module_cache__[moduleId];
    /******/ if (cachedModule !== undefined) {
      /******/ return cachedModule.exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/ var module = (__webpack_module_cache__[moduleId] = {
      /******/ // no module.id needed
      /******/ // no module.loaded needed
      /******/ exports: {},
      /******/
    });
    /******/
    /******/ // Execute the module function
    /******/ __webpack_modules__[moduleId](
      module,
      module.exports,
      __webpack_require__
    );
    /******/
    /******/ // Return the exports of the module
    /******/ return module.exports;
    /******/
  }
  /******/
  /************************************************************************/
  /******/ /* webpack/runtime/define property getters */
  /******/ (() => {
    /******/ // define getter functions for harmony exports
    /******/ __webpack_require__.d = (exports, definition) => {
      /******/ for (var key in definition) {
        /******/ if (
          __webpack_require__.o(definition, key) &&
          !__webpack_require__.o(exports, key)
        ) {
          /******/ Object.defineProperty(exports, key, {
            enumerable: true,
            get: definition[key],
          });
          /******/
        }
        /******/
      }
      /******/
    };
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/hasOwnProperty shorthand */
  /******/ (() => {
    /******/ __webpack_require__.o = (obj, prop) =>
      Object.prototype.hasOwnProperty.call(obj, prop);
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/make namespace object */
  /******/ (() => {
    /******/ // define __esModule on exports
    /******/ __webpack_require__.r = (exports) => {
      /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
        /******/ Object.defineProperty(exports, Symbol.toStringTag, {
          value: "Module",
        });
        /******/
      }
      /******/ Object.defineProperty(exports, "__esModule", { value: true });
      /******/
    };
    /******/
  })();
  /******/
  /************************************************************************/
  var __webpack_exports__ = {};
  // This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
  (() => {
    /*!********************************************************!*\
  !*** ./src/scripts/templates/product/salon-product.js ***!
  \********************************************************/
    __webpack_require__.r(__webpack_exports__);
    /* harmony export */ __webpack_require__.d(__webpack_exports__, {
      /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
      /* harmony export */
    });
    /* harmony import */ var alpinejs_src_datas__WEBPACK_IMPORTED_MODULE_0__ =
      __webpack_require__(
        /*! alpinejs/src/datas */ "./node_modules/alpinejs/src/datas.js"
      );
    function _toConsumableArray(arr) {
      return (
        _arrayWithoutHoles(arr) ||
        _iterableToArray(arr) ||
        _unsupportedIterableToArray(arr) ||
        _nonIterableSpread()
      );
    }
    function _nonIterableSpread() {
      throw new TypeError(
        "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
      );
    }
    function _unsupportedIterableToArray(o, minLen) {
      if (!o) return;
      if (typeof o === "string") return _arrayLikeToArray(o, minLen);
      var n = Object.prototype.toString.call(o).slice(8, -1);
      if (n === "Object" && o.constructor) n = o.constructor.name;
      if (n === "Map" || n === "Set") return Array.from(o);
      if (
        n === "Arguments" ||
        /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
      )
        return _arrayLikeToArray(o, minLen);
    }
    function _iterableToArray(iter) {
      if (
        (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null) ||
        iter["@@iterator"] != null
      )
        return Array.from(iter);
    }
    function _arrayWithoutHoles(arr) {
      if (Array.isArray(arr)) return _arrayLikeToArray(arr);
    }
    function _arrayLikeToArray(arr, len) {
      if (len == null || len > arr.length) len = arr.length;
      for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
      return arr2;
    }

    var product = function product(_ref) {
      var product = _ref.product,
        variant = _ref.variant;
      return {
        urlParams: "",
        variants: null,
        selectedVariant: null,
        selectedSwatch: null,
        currentProduct: null,
        selectedVariantDimensions: null,
        optionRadios: null,
        optionAllRadios: null,
        slider: null,
        selectedVariantImageID: 0,
        productGalleryContainer: null,
        showProductFullSpecs: false,
        productFullSpecsDrawerIsOpen: false,
        productOptionsContainer: null,
        selectedOptionsValuesId: [],
        unavailableVariants: null,
        unavailableOptionsValues: [],
        unavailableVariantsTitles: [],
        selectedOptionPosition: 0,
        hasDimensions: false,
        init: function init() {
          this.urlParams = new URL(window.location.href);
          this.currentProduct = product;
          this.variants = product.variants;
          this.selectedVariant = variant;
          this.optionAllRadios = _toConsumableArray(
            document.querySelectorAll("[data-options], [data-options-select]")
          );
          this.selectedVariantImageID = this.selectedVariant.featured_media.id;
          this.productGalleryContainer = this.$refs.productGallery;
          this.drawURL();
          this.getSelectedVariantDimensions();
        },
        getSelectedVariant: function getSelectedVariant(event, variant) {
          var _this = this;
          this.selectedVariant = this.variants.find(function (variant) {
            const selectedValues = _this.optionAllRadios
              .map(function (input) {
                if (input.tagName.toLowerCase() === "select") {
                  return input.value;
                } else if (input.type === "radio" && input.checked) {
                  return input.value;
                }
                return null;
              })
              .filter(Boolean);

            return (
              variant.title.trim().toLowerCase() ===
              selectedValues.join(" / ").trim().toLowerCase()
            );
          });
          if (this.selectedVariant) {
            this.selectedVariantImageID =
              this.selectedVariant.featured_media.id;
            this.drawURL();
            this.getSelectedVariantDimensions();
            this.slideToSelectedVariantImage(this.selectedVariantImageID);
          }
          if (this.currentProduct.options.length > 1) {
            this.setAvailableVariants(event);
          }
        },
        setAvailableVariants: function setAvailableVariants(event) {
          var _this2 = this;
          this.selectedOptionPosition =
            this.selectedVariant.options.indexOf(event.target.value) + 1;
          this.unavailableOptionsValues = [];
          this.unavailableVariantsTitles = [];
          var optionsList = _toConsumableArray(
            document.querySelectorAll(".options-list")
          );
          var notSelectedOptionsList = optionsList.filter(function (list) {
            return (
              +list.getAttribute("data-option-position") !==
              _this2.selectedOptionPosition
            );
          });
          this.unavailableVariants = this.variants
            .filter(function (variant) {
              return variant.options.includes(event.target.value);
            })
            .filter(function (variant) {
              return !variant.available;
            });
          notSelectedOptionsList.forEach(function (option, index) {
            _this2.optionRadios = option.querySelectorAll(
              "[data-product-variants]"
            );
          });
          this.optionRadios.forEach(function (radio) {
            radio.disabled = false;
          });
          if (this.unavailableVariants.length > 0) {
            this.unavailableVariants.forEach(function (variant) {
              if (!_this2.unavailableVariantsTitles.includes(variant.title)) {
                _this2.unavailableVariantsTitles.push(variant.title);
              }
              variant.options.forEach(function (option) {
                if (!_this2.unavailableOptionsValues.includes(option)) {
                  _this2.unavailableOptionsValues.push(option);
                }
              });
            });
          }
          if (this.unavailableOptionsValues.length > 0) {
            this.unavailableOptionsValues.forEach(function (value) {
              _this2.optionRadios.forEach(function (radio) {
                if (radio.value === value && value !== event.target.value) {
                  radio.disabled = true;
                }
              });
            });
          }
        },
        getSelectedVariantDimensions: function getSelectedVariantDimensions() {
          var _this3 = this;
          if (JSON.parse(this.$refs.variantDimensions.innerHTML)) {
            this.selectedVariantDimensions = JSON.parse(
              this.$refs.variantDimensions.innerHTML
            ).variant_dimensions.find(function (item) {
              return item[_this3.selectedVariant.id];
            })[this.selectedVariant.id];
          }
          if (this.selectedVariantDimensions) {
            this.hasDimensions = Object.keys(
              this.selectedVariantDimensions
            ).length;
          }
        },
        slideToSelectedVariantImage: function slideToSelectedVariantImage(id) {
          this.selectedIndex = this.productGalleryContainer
            .querySelector('[data-image-id="'.concat(id, '"]'))
            .getAttribute("data-slide-index");
          this.slider.slideTo(this.selectedIndex, 100, null);
        },
        incrementQty: function incrementQty(event) {
          Alpine.store("cart").qty++;
        },
        decrementQty: function decrementQty(event) {
          if (Alpine.store("cart").qty > 1) {
            Alpine.store("cart").qty--;
          }
        },
        drawURL: function drawURL() {
          this.urlParams.searchParams.set("variant", this.selectedVariant.id);
          history.replaceState(
            this.selectedVariant.id,
            "variant",
            this.urlParams
          );
        },
        openProductFullSpecsDrawer: function openProductFullSpecsDrawer() {
          var _this4 = this;
          document.body.classList.add("overflow-hidden");
          this.showProductFullSpecs = true;
          setTimeout(function () {
            _this4.productFullSpecsDrawerIsOpen = true;
          }, 100);
        },
        closeProductFullSpecsDrawer: function closeProductFullSpecsDrawer() {
          var _this5 = this;
          this.productFullSpecsDrawerIsOpen = false;
          setTimeout(function () {
            document.body.classList.remove("overflow-hidden");
            _this5.showProductFullSpecs = false;
          }, 300);
        },
      };
    };
    /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = product;
    window.addEventListener("alpine:init", function () {
      Alpine.data("mainProduct", product);
    });
  })();

  /******/
})();
